import {useState,useEffect,useRef} from "react";
import {Link,useNavigate} from "react-router-dom";
import FeatherIcon from "feather-icons-react";
import ImageWithBasePath from "../../../../core/img";
import {all_routes} from "../../../router/all_routes";
import Table from "../../../../core/dataTable/index";
import {Toaster} from 'react-hot-toast';
// -- biz9 --
import {Str,DateTime} from "biz9-utility";
import {Image_Format} from "biz9-image";
import {Portal_Url,Portal_Table,Portal_Type,Portal_Remote_Data,Portal_Remote_Image,Portal_Remote_CMS} from "biz9-portal-app";
import {Message,Type,Url,Field,Title,Config} from "../../../../constant";
import {App,Data,Dashboard,Event,Image,Style,Service_Industry,User,Toast_Message,Template,Storage,System} from "../../../../project";
import {Data_Logic} from "biz9-data-app";

const Dashboard_App_Order = () => {
    const timeoutRef = useRef(null);
    const [val_sub_page_title,setValSubPageTitle] = useState(Str.get_table_by_name(Portal_Table.ORDER,{plural:true}));
    const [val_search,setValSearch] = useState("");
    const [stop_search,setStopSearch] = useState('');
    const [orders,setOrders] = useState([]);
 // -- paging --
    const [val_page_current,setValPageCurrent] = useState(Type.PAGE_CURRENT);
    const [val_page_size,setValPageSize] = useState(Type.PAGE_SIZE);
    const [val_total,setValTotal] = useState(0);
    const [val_filter,setValFilter] = useState({});
    const [val_sort_by,setValSortBy] = useState({});
    const [val_option,setValOption] = useState({});

    const columns = [
    {
title: "Order #",
           dataIndex: "order_number",
           key: "order_number",
           render: (text: string, record: any) => (
                   <h2 className="table-avatar d-flex align-items-center">
                   <Link to={all_routes.dashboard_admin_order_detail+"?order_number="+record.order_number} className="text-dark">
                   {record.order_number}
                   </Link>
                   </h2>
                   ),
           sorter: true
    },
 {
title: "Status",
       dataIndex: "status",
       key: "status",
       render: (text: string, record: any) => (
               <>
                {Str.get_table_by_name(record.status)}
                </>
               ),
       sorter: true
    },
 {
        title: "UserName",
        dataIndex: "user_title",
        key: "user_title",
        render: (text: string, record: any) => (
                    <h2 className="table-avatar d-flex align-items-center">
                   <Link to={all_routes.dashboard_admin_user_detail+"?id="+record.user_id} className="avatar">
                   <ImageWithBasePath src={Image.get_url(record.user_image_filename,Image_Format.SQUARE_THUMB)} />
                   </Link>
                   <Link to={all_routes.dashboard_admin_user_detail+"?id="+record.user_id} className="text-dark">
                   {record.user_title}
                   </Link>
                   </h2>
                  ),
             sorter: true
    },
 {
title: "Grand Total",
       dataIndex: "grand_total",
       key: "grand_total",
       render: (text: string, record: any) => (
               <>
                {Str.get_money(record.grand_total)}
                </>
               ),
       sorter: true
    },
 {
title: "Date & Time",
       dataIndex: "date_create",
       key: "date_create",
       render: (text: string, record: any) => (
               <>
                {DateTime.get_date(record.date_create) }{" "}
                {DateTime.get_time(record.date_create) }
                </>
               ),
        sorter: true
  },
 {
title: "Payment Plan",
       dataIndex: "payment_plan",
       key: "payment_plan",
       render: (text: string, record: any) => (
               <>
                {record.payment_plan}
                </>
               ),
       sorter: true
    },
    {
title: "Action",
       dataIndex: "action",
       render: (res: string, record: any) => (
               <>
               <div className="dropdown dropdown-action">
               <Link to="#" className="action-icon" data-bs-toggle="dropdown" aria-expanded="false">
               <FeatherIcon icon="more-vertical" />
               </Link>
               <div className="dropdown-menu dropdown-menu-right">
               <Link className="dropdown-item" to="#" onClick={(e) => { {btn_delete(record.id)} }} >
               <FeatherIcon icon="trash" /> Delete
               </Link>
               </div>
               </div>
               </>
               ),
    },
    ];
    useEffect(() => {
            Toast_Message.loading(Message.LOADING);
    get_data();
        if(timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    },[]);
    async function get_data() {
        /*
        let option = {};
        //need to add foreign_user
        let search = Data_Logic.get_search(Portal_Table.ORDER,val_filter,{page_current:val_page_current,page_size:val_page_size});
        let [response,data] = await Portal_Remote_CMS.search(App.get_url(Portal_Url.DATA_SEARCH),search,{category:Portal_Table.ORDER});
        setOrders(data.items);
        Toast_Message.dismiss();
        */
    };
     const post_search = (e) => {
       const value = e.target.value;
        setValSearch(value);
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        timeoutRef.current = setTimeout(() => {
            setStopSearch(value);
            let filter = {};
            if(!Str.check_is_null(value)){
                filter ={title:{$regex:".*"+val_search,$options:"i"}};
            }
            let search = Data_Logic.get_search(Portal_Table.ORDER,filter);
            post_search_data(search);
       }, 500);
    };
    async function post_search_data(search) {
        /*
        Toast_Message.loading(Message.SEARCHING);
        let [response,data] = await Portal_Remote_Data.search(App.get_url(Portal_Url.DATA_SEARCH),search);
        setOrders(data.items);
        Toast_Message.dismiss();
        */
   }
    async function btn_copy(id: any) {
        /*
        if (window.confirm(Message.CONFIRM)) {
            Toast_Message.loading(Message.SAVING);
            let [response,data] = await Portal_Remote_Data.copy(App.get_url(Portal_Url.DATA_COPY),Portal_Table.ORDER,id);
            setOrders([data.copy_item, ...orders]);
            Toast_Message.success(response.message);
        }
        */
    };
    async function btn_delete(id: any) {
        /*
        if(window.confirm(Message.CONFIRM)){
            Toast_Message.loading(Message.DELETING);
            let [response,data] = await Portal_Remote_Data.delete(App.get_url(Portal_Url.DATA_DELETE),Portal_Table.ORDER,id);
            Toast_Message.success(response.message);
            setOrders(orders.filter(item=>item.id!==id));
        }
        */
    };
    const updateNewItem = (item) => {
        setOrders([item, ...orders]);
    };
    return (
            <>
            <Toaster />
            {/* Page Content */}
            <div className="page-wrapper">
            <div className="container px-0">
            {/*Inner Content */}
            <div className="content mx-4 mb-4">
            <div className="main-title my-4">
            <h4>{val_sub_page_title}</h4>
            </div>
            <div className="wallet-wrap">
            <div className="wallet-list">
            <div className="wallet-item mt-10">
            <div  className="pt-10">
            <input hidden={orders.length<=0} type='text' autoComplete='off' className='form-control' placeholder={"Search"} value={val_search} onChange={post_search}/>
            </div>
            </div>
            </div>
            <div className="d-flex align-items-center">
            <Link hidden={true} to="#" data-bs-toggle="modal" data-bs-target="#withdraw" className="btn btn-primary">
            {Title.LABEL_ADD}
            </Link>
            </div>
            </div>
            <div className="table-responsive custom-table">

 <Table onUpdate={setOrders} allow_multiple={true}  page_size={val_page_size} page_current={val_page_current} total={val_total} option={val_option} sort_by={val_sort_by} filter={val_filter} table={Portal_Table.ORDER} dataSource={orders} columns={columns} Selection={false} />

            </div>
            <div className="table-footer">
            <div id="tablepage" />
            </div>
            </div>
            {/* /Inner Content */}
    </div>
        </div>
        {/* /Page Content */}
        </>
        );
};
export default Dashboard_App_Order;
